import { BaseHTMLAttributes, FunctionComponent, ReactNode } from 'react'
import Box from '@mui/material/Box'

type TabPanelProps = BaseHTMLAttributes<HTMLDivElement> & {
  value: string
  index: string
  children: ReactNode
}

const TabPanel: FunctionComponent<TabPanelProps> = ({
  value,
  index,
  children,
  ...rest
}) => {
  const isVisible = value === index

  return (
    <Box
      role="tabpanel"
      hidden={!isVisible}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...rest}
    >
      {isVisible && <Box>{children}</Box>}
    </Box>
  )
}

export default TabPanel
